import slideDown from "@/scripts/helpers/slideDown.js";
import slideUp from "@/scripts/helpers/slideUp.js";
import loaded from '@/scripts/helpers/loaded';

loaded(() => {
    document.querySelectorAll('.accordion-title').forEach(function(element) {
        element.addEventListener('click', function(e){
            e.preventDefault();
            var width = window.innerWidth,
                parent = this.closest('li'),
                content = parent.querySelector('div'),
                hasClass = this.classList.contains('active--item');
            if(width < 992){
                if(!hasClass){
                    this.classList.add('active--item');
                    slideDown(content);
                }else{
                    this.classList.remove('active--item');
                    slideUp(content);
                }
            }
        });
    });
});
